import { DELETE_TENANT_REQUEST } from '../constants/constants';

export const deleteTenant = (payload) => {
    return {
      type: DELETE_TENANT_REQUEST,
      payload: payload,
    };
  };